"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notificationsActions = exports.NotificationsActionTypes = void 0;
const utils_1 = require("./utils");
var NotificationsActionTypes;
(function (NotificationsActionTypes) {
    NotificationsActionTypes["ADD_TOAST_TO_QUEUE"] = "notifications/ADD_TOAST_TO_QUEUE";
    NotificationsActionTypes["REMOVE_TOAST_FROM_QUEUE"] = "notifications/REMOVE_TOAST_FROM_QUEUE";
    NotificationsActionTypes["SHOW_TOAST"] = "notifications/SHOW_TOAST";
    NotificationsActionTypes["HIDE_TOAST"] = "notifications/HIDE_TOAST";
    NotificationsActionTypes["RESET_WHOLE_STORE"] = "notifications/RESET_WHOLE_STORE";
})(NotificationsActionTypes = exports.NotificationsActionTypes || (exports.NotificationsActionTypes = {}));
;
exports.notificationsActions = {
    addToastToQueue: (0, utils_1.makeActionCreator)(NotificationsActionTypes.ADD_TOAST_TO_QUEUE),
    removeToastFromQueue: (0, utils_1.makeActionCreator)(NotificationsActionTypes.REMOVE_TOAST_FROM_QUEUE),
    showToast: (0, utils_1.makeActionCreator)(NotificationsActionTypes.SHOW_TOAST),
    hideToast: (0, utils_1.makeActionCreator)(NotificationsActionTypes.HIDE_TOAST),
    resetWholeStore: (0, utils_1.makeActionCreator)(NotificationsActionTypes.RESET_WHOLE_STORE),
};
